//todo: refactor axios usage to use singleton pattern
const axios = require('axios');

const URL = 'https://us-central1-staderverse-apis-mainnet.cloudfunctions.net/kyvApiGetMetricsByValidator';
const HEADERS = { "Content-Type": "application/json" };
const validatorCache = new Map();

function cacheHasAndIsValid(validator) {
    return validatorCache.has(validator) &&
        validatorCache.get(validator).expiresAt > Date.now();
}

async function getValidatorAprDetails(validator) {
    if (cacheHasAndIsValid(validator)) {
        return validatorCache.get(validator).data;
    }
    let timestampOffset=0;
    let timestampLimit=30;
    const config = {
        method: "post",
        url: URL,
        headers: HEADERS,
        data: JSON.stringify({ validator, timestampOffset, timestampLimit }),
    };
    const response = await axios(config);
    validatorCache.set(validator, {
        expiresAt: new Date(new Date().getTime() + (24 * 3600 * 1000)),
        data: response.data
    });
    // console.log(response.data.metrics);

    return response.data.metrics
}

const mapValidatorsApr = async (validators) => {
    const mappedValidatorPromises = validators
        .map((validator) => {
            return mapValidatorApr(validator);
        });
    return Promise.all(mappedValidatorPromises);
}

const mapValidatorApr = async (validator) => {
    return getValidatorAprDetails(validator)
        .then((data) => {
            var aprList=[];
            // console.log(data);
            var currind=0;
            var sumOfAprs=0;
            for( let currData of data )
            {
                // console.log(currData.apr);
                var currApr={};
                currApr[currind]=currData.apr;
                // console.log(currApr);
                // console.log(currData.apr);
                aprList.push( (parseFloat(currData.apr) * 100).toFixed(2) );
                currind+=1;
                sumOfAprs+=currData.apr;
            }


            return {validator,"avgapr":((sumOfAprs/30) * 100).toFixed(2), ...aprList}
        });
}

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {mapValidatorsApr, mapValidatorApr};
